export default __webpack_public_path__ + "img/partnership7-e4582e5e0bc3a60d4606fd352f2d914f.png";